import { PROFILE_ERROR, PROFILE_SUCCESS, EDIT_PROFILE, RESET_PROFILE_FLAG } from "./actionTypes"

interface ProfileState {
  error: string;
  success: string | null;
}

interface ProfileAction {
  type: string;
  payload?: any;
}

const initialState: ProfileState = {
  error: "",
  success: "",
}

const profile = (state: ProfileState = initialState, action: ProfileAction): ProfileState => {
  switch (action.type) {
    case EDIT_PROFILE:
      state = { ...state }
      break
    case PROFILE_SUCCESS:
      state = { ...state, success: action.payload }
      break
    case PROFILE_ERROR:
      state = { ...state, error: action.payload }
      break
    case RESET_PROFILE_FLAG :
      state = { ...state, success: null, error: "" }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default profile
